import { canEditBusinessCover } from '../../../../utils/accessService';
import { useTranslation } from '../../../../utils/useTranslation';
import { Button } from '../../../input/Button';
import { Box } from '../../../layout/Box';
import { Image } from '../../../media/Image';
import { MediaCover } from '../../../media/MediaCover';
import { ReactComponent as BusinessCoverSvg } from '../../../resources/defaultCover.svg';
import { BUSINESS_COVER_RATIO } from '../constants';
import { CoverProps } from '../types';
import { ContextMenu } from './ContextMenu';

export const Cover = ({ business, user, onReport, onPersistBusinessCover }: CoverProps) => {
    const t = useTranslation();

    return (
        <Box position="relative">
            <Box zIndex={10} position="absolute" top={0} right={0}>
                <ContextMenu isCoverVisible business={business} user={user} onReport={onReport} />
            </Box>
            <MediaCover ratio={BUSINESS_COVER_RATIO}>
                {business.coverUrl ? <Image src={business.coverUrl} /> : <BusinessCoverSvg />}
            </MediaCover>
            {canEditBusinessCover(business, user) && (
                <Button
                    size="xs"
                    position="absolute"
                    variant="blur"
                    color="secondary"
                    bottom={{ xs: 1, sm: 2 }}
                    right={{ xs: 2, sm: 3 }}
                    onClick={onPersistBusinessCover}
                >
                    {t('Изменить обложку')}
                </Button>
            )}
        </Box>
    );
};
